export const GET_SECTIONS = 'GET_SECTIONS'
export const GET_COURSES = 'GET_COURSES'
export const ADD_COURSE = 'ADD_COURSE';
export const GET_ALL_SECTION_STUDENTS = 'GET_ALL_SECTION_STUDENTS'
export const GET_STUDENT = 'GET_STUDENT';
export const UPDATE_STUDENT = 'UPDATE_STUDENT'
export const GET_STUDENT_BY_ID = 'GET_STUDENT_BY_ID';
export const ADD_SECTION = 'ADD_SECTION'
export const GET_INSTRUCTORS = 'GET_INSTRUCTORS'
export const ADD_INSTRUCTOR = 'ADD_INSTRUCTOR'
export const ADD_ALL_STUDENTS_TO_SECTION = 'ADD_ALL_STUDENTS_TO_SECTION'
export const ADD_STUDENT_TO_SECTION = 'ADD_STUDENT_TO_SECTION'
export const GET_ABSENCE_FOR_STUDENT = 'GET_ABSENCE_FOR_STUDENT';
export const GET_EXCUSE_FOR_STUDENT = 'GET_EXCUSE_FOR_STUDENT';
export const DELETE_ABSENCE = 'DELETE_ABSENCE';
export const LOGIN="LOGIN"
export const GET_INSTRUCTOR_SECTIONS = 'GET_INSTRUCTOR_SECTIONS'
export const DELETE_COURSE='DELETE_COURSE'
export const DELETE_INSTRUCTOR = 'DELETE_INSTRUCTOR';
export const DELETE_STUDENT_FROM_SECTION = 'STUDENTS_SECTIONS'
export const LOGOUT = 'LOGOUT'
export const GET_INSTRUCTOR = 'GET_INSTRUCTOR'
export const UPDATE_INSTRUCTOR = 'UPDATE_INSTRUCTOR'
export const DELETE_SECTION = 'DELETE_SECTION';
export const GET_SECTION_BY_ID='GET_SECTION_BY_ID'
export const UPDATE_SECTION='UPDATE_SECTION'
export const UPDATE_COURSE = 'UPDATE_COURSE'
export const ADD_EXCUSE = 'ADD_EXCUSE'
// dashboard 
export const MOST_INSTRUCTORS = 'MOST_INSTRUCTORS'
export const MOST_SECTIONS = 'MOST_SECTIONS'
export const MOST_COURSES = 'MOST_COURSES'
export const NUMBER_ABSENCES='NUMBER_ABSENCES'
export const TOTAL_COUNT ='TOTAL_COUNT';
